<template>
    <div class="order-history">
        <Accordion class="order-history-accordion">
            <template #head>
                <div>Order History</div>
            </template>

            <template #content>
                <SimpleFlexTable
                    :data="sortedHistory"
                    :head="['Date', 'Source State', 'Destination State', 'Actions']"
                >
                    <template #default="{ item: transition }">
                        <span>{{ formatLocaleTimestamp(transition.modified, $i18n.locale) }}</span>
                        <span>
                            {{
                                transition.source_state &&
                                transition.source_state.label[$i18n.locale]
                            }}
                        </span>
                        <span>
                            {{
                                transition.destination_state &&
                                transition.destination_state.label[$i18n.locale]
                            }}
                        </span>
                        <span>
                            <button
                                v-if="order.permissions.restart_transition_action"
                                type="button"
                                class="button button--blank"
                                @click="openTransitionActions(transition)"
                            >
                                Actions
                            </button>
                        </span>
                    </template>
                    <template #empty>
                        <div>No History</div>
                    </template>
                </SimpleFlexTable>
            </template>
        </Accordion>
        <OrderTransitionActions ref="actions" />
    </div>
</template>

<script>
import { Accordion } from '@speechki-frontend/shared/ui/Accordion/';
import SimpleFlexTable from '@speechki-frontend/shared/ui/SimpleFlexTable/SimpleFlexTable';
import OrderTransitionActions from '../OrderTransitionActions/OrderTransitionActions';

import { formatLocaleTimestamp } from '@speechki-frontend/shared/helpers/functions';

export default {
    name: 'OrderHistory',
    components: {
        Accordion,
        SimpleFlexTable,
        OrderTransitionActions,
    },
    props: {
        history: {
            type: Array,
            default: () => [],
        },
        order: {
            type: Object,
            required: true,
        },
    },
    computed: {
        sortedHistory() {
            return this.history
                .slice()
                .sort((a, b) => new Date(b.modified).getTime() - new Date(a.modified).getTime());
        },
    },
    methods: {
        formatLocaleTimestamp,
        openTransitionActions(transition) {
            this.$refs.actions.open(transition);
        },
    },
};
</script>

<style lang="scss" src="./OrderHistory.scss"></style>
